import React from "react";
import {Col, Row,} from "reactstrap";
import "../../../assets/css/animation.css";
import className from "classnames";
import ContentLoader from 'react-content-loader'
import ButtonDesign from "../../../components/ButtonDesign";
import assets from "../../../util/assets";
import TopSectionBroadcastDetail from "./broadcast-detail/TopSectionBroadcastDetail";
import like_inactive from "../../../assets/images/broadcast/video/like.svg";

const TopSectionBroadcastDetailLoader = () => (
    <ContentLoader
        height={49}
        speed={1}
        primaryColor="#cdcdce"
        secondaryColor="#eeeeef"
        viewBox="0 0 380 70">

        {/* Only SVG shapes */}
        <rect x="0" y="0" rx="5" ry="5" width="46" height="46"/>
        <rect x="54" y="0" rx="4" ry="4" width="231" height="24"/>
        <rect x="54" y="27" rx="3" ry="3" width="352" height="20"/>

    </ContentLoader>
);

const ButtonLoader = () => (
    <ContentLoader
        height={49}
        speed={1}
        primaryColor="#cdcdce"
        secondaryColor="#eeeeef"
        viewBox="0 0 380 70">

        {/* Only SVG shapes */}
        {
            buttons.map((button,index)=>{
                return <rect key={`buttons-rect-${index}`} x={index * 56} y="0" rx="5" ry="5" width="46" height="46"/>
            })
        }
    </ContentLoader>
);

const buttons = [{
    title:'chat',
    activeState:assets.broadcast.top_section.chat_active,
    inActiveState:assets.broadcast.top_section.chat_inactive
},{
    title:'onetoone',
    activeState:assets.broadcast.top_section.one_to_one_active,
    inActiveState:assets.broadcast.top_section.one_to_one_inactive
},{
    title:'group',
    activeState:assets.broadcast.top_section.group_active,
    inActiveState:assets.broadcast.top_section.group_inactive
},{
    title:'tip',
    activeState:assets.broadcast.top_section.tip_active,
    inActiveState:assets.broadcast.top_section.tip_inactive
},{
    title:'tipgoal',
    activeState:assets.broadcast.top_section.tipgoal_active,
    inActiveState:assets.broadcast.top_section.tipgoal_inactive
}]

const TopSection = (props) => {

    const getColumnGrid = ()=>{
        if(props.hasOwnProperty("innerWidth")){
            if(props.innerWidth > 0 && props.innerWidth <= 1300){
                return 6;
            }else{
                return (props.activeRightLayout === "" ? 6 : 4);
            }
        }
    }

    if(props.broadcast){
        return (
            <Row style={{height: 64}}>
                <Col md={getColumnGrid()} className="text-left no-margin" style={{paddingLeft:15,paddingRight:0}}>
                    <TopSectionBroadcastDetail
                        broadcast={props.broadcast}
                        userName={props.broadcast.broadcaster.username}
                        userImage={props.broadcast.broadcaster.profile_pic}
                        status={props.broadcast.broadcaster.status}
                        isTitle={true}
                    />
                </Col>

                <Col md={getColumnGrid()}  className="text-right card-title">

                    {
                        props.hasOwnProperty("type") &&
                        props.type === "viewer" &&
                        <ButtonDesign
                            btName={props.broadcast.broadcaster.is_following ? "Unfollow" : "Follow"}
                            btColor="link"
                            btClass="text-decoration-none bg-white rounded-0 followbtn btn-with-shadow"
                            onclickFunction={() => props.clickedOnFollowUnFollow()}>
                            {
                                !props.broadcast.broadcaster.is_following ?
                                    <i className="fas fa-plus" style={{paddingRight: 6}}/> :
                                    <i className='fas fa-times' style={{paddingRight: 6}}/>
                            }
                        </ButtonDesign>
                    }

                    <ButtonDesign
                        btColor="link"
                        has_notification={props.notification.chat}
                        btClass={
                            className("text-decoration-none bg-white rounded-0 btn-with-shadow btn-tip-with-blue-bg", {
                                "bg-blue": props.activeRightLayout === "chat"
                            })
                        }
                        onclickFunction={() => props.toggleRightLayout("chat")}>
                        <img width={23}
                             src={props.activeRightLayout === "chat" ? assets.broadcast.top_section.chat_active : assets.broadcast.top_section.chat_inactive}/>
                    </ButtonDesign>

                    {
                        props.hasOwnProperty("type") &&
                        props.type === "broadcaster" &&
                        <ButtonDesign
                            btColor="link"
                            has_notification={props.notification.onetoone}
                            btClass={
                                className("text-decoration-none bg-white rounded-0 btn-with-shadow btn-tip-with-blue-bg", {
                                    "bg-blue": props.activeRightLayout === "onetoone"
                                })
                            }
                            onclickFunction={() => props.toggleRightLayout("onetoone")}>
                            <img width={23}
                                 src={props.activeRightLayout === "onetoone" ? assets.broadcast.top_section.one_to_one_active : assets.broadcast.top_section.one_to_one_inactive}/>
                        </ButtonDesign>
                    }

                    {
                        props.hasOwnProperty("type") &&
                        props.type === "broadcaster" &&
                        <ButtonDesign
                            btColor="link"
                            has_notification={props.notification.group}
                            btClass={
                                className("text-decoration-none bg-white rounded-0 btn-with-shadow btn-tip-with-blue-bg", {
                                    "bg-blue": props.activeRightLayout === "group"
                                })
                            }
                            onclickFunction={() => props.toggleRightLayout("group")}>
                            <img width={23}
                                 src={props.activeRightLayout === "group" ? assets.broadcast.top_section.group_active : assets.broadcast.top_section.group_inactive}/>
                        </ButtonDesign>
                    }

                    <ButtonDesign
                        btColor="link"
                        has_notification={props.notification.tip}
                        btClass={
                            className("text-decoration-none bg-white rounded-0 btn-with-shadow btn-tip-with-blue-bg", {
                                "bg-blue": props.activeRightLayout === "tip"
                            })
                        }
                        onclickFunction={() => props.toggleRightLayout("tip")}>
                        {
                            props.type === "viewer"
                            ?
                                <img height={23}
                                     src={props.activeRightLayout === "tip" ? assets.broadcast.top_section.like_active : assets.broadcast.top_section.like_inactive}/>
                                     :
                                <img width={23}
                                     src={props.activeRightLayout === "tip" ? assets.broadcast.top_section.tip_active : assets.broadcast.top_section.tip_inactive}/>
                        }
                    </ButtonDesign>


                    {
                        props.broadcast &&
                        props.broadcast.hasOwnProperty("tip_goal") &&
                        Array.isArray(props.broadcast.tip_goal) &&
                        props.broadcast.tip_goal.length > 0 &&
                        <ButtonDesign
                            btColor="link"
                            has_notification={props.notification.tipgoal}
                            btClass={
                                className("text-decoration-none bg-white rounded-0 btn-with-shadow btn-tip-with-blue-bg", {
                                    "bg-blue": props.activeRightLayout === "tipgoal"
                                })
                            }
                            onclickFunction={() => props.toggleRightLayout("tipgoal")}>
                            <img width={23}
                                 src={props.activeRightLayout === "tipgoal" ? assets.broadcast.top_section.tipgoal_active : assets.broadcast.top_section.tipgoal_inactive}/>
                        </ButtonDesign>

                    }

                    {
                        props.broadcast &&
                        props.broadcast.hasOwnProperty("tip_goal") &&
                        Array.isArray(props.broadcast.tip_goal) &&
                        props.broadcast.tip_goal.length > 0 &&
                        <div id="tip-goal-progress"
                             style={{position: 'absolute', right: 4, top: 0, display: 'none', cursor: 'pointer'}}
                             onClick={() => props.toggleRightLayout("tipgoal")}>
                            <svg width="60" height="44">
                                <path
                                    d="M2,0 L47,0 C48.1045695,-2.02906125e-16 49,0.8954305 49,2 L49,42 C49,43.1045695 48.1045695,44 47,44 L2,44 C0.8954305,44 1.3527075e-16,43.1045695 0,42 L0,2 C-5.7935996e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z"
                                    id="path-1" fill-opacity="0" strokeWidth="0.5"></path>
                                <path stroke="#1B75BC" strokeWidth="2"
                                      d="M47,1 C47.2761424,1 47.5261424,1.11192881 47.7071068,1.29289322 C47.8880712,1.47385763 48,1.72385763 48,2 L48,2 L48,42 C48,42.2761424 47.8880712,42.5261424 47.7071068,42.7071068 C47.5261424,42.8880712 47.2761424,43 47,43 L47,43 L2,43 C1.72385763,43 1.47385763,42.8880712 1.29289322,42.7071068 C1.11192881,42.5261424 1,42.2761424 1,42 L1,42 L1,2 C1,1.72385763 1.11192881,1.47385763 1.29289322,1.29289322 C1.47385763,1.11192881 1.72385763,1 2,1 L2,1 Z"
                                      id="heart-path" fill-opacity="0" strokeWidth="1.5"
                                      stroke="#1B75BC"
                                      strokeLinejoin="round"></path>
                            </svg>
                        </div>
                    }
                </Col>
            </Row>
        )
    }else{
        return (
            <Row style={{height: 64}}>
                <Col sm={getColumnGrid()} className="text-left">
                    <TopSectionBroadcastDetailLoader/>
                </Col>
                <Col sm={getColumnGrid()} className="text-right card-title" style={{marginLeft:112}}>
                    <ButtonLoader/>
                </Col>
            </Row>
        )
    }
};

export default TopSection;